import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { cartApi } from '@/api/endpoints';
import { useAuthStore } from '@/store/authStore';
import Avatar from '@/components/common/Avatar';
import { NAV_ITEMS, isNavActive } from './navItems';

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const isManager = useAuthStore((s) => s.isManager);

  // NavLink 의 isActive 는 경로만 비교해서 /products 와 /products?sortBy=popular 를
  // 구분하지 못한다. 쿼리까지 봐야 하므로 활성 여부를 직접 계산한다.
  const query = new URLSearchParams(location.search);

  const { data: cartCount } = useQuery({
    queryKey: ['cart', 'count'],
    queryFn: cartApi.count,
    enabled: Boolean(user),
    staleTime: 10_000,
  });

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <header className="header">
      <div className="container header__inner">
        <Link to="/" className="header__logo">
          Gency03<span style={{ color: 'var(--gray-900)' }}>Mall</span>
        </Link>

        <nav className="header__nav">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              className={isNavActive(item, location.pathname, query) ? 'is-active' : ''}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="header__spacer" />

        <div className="header__actions">
          {user ? (
            <>
              <Link to="/cart" className="cart-badge">
                장바구니
                {cartCount ? <span className="cart-badge__count">{cartCount}</span> : null}
              </Link>
              <Link to="/orders">주문조회</Link>
              <Link to="/mypage" className="header__user">
                <Avatar src={user.profileImageUrl} size={28} />
                {user.nickname || user.name}님
              </Link>
              {isManager() && (
                <Link to="/admin" className="badge badge--info">
                  관리자
                </Link>
              )}
              <button type="button" className="btn btn--ghost btn--sm" onClick={handleLogout}>
                로그아웃
              </button>
            </>
          ) : (
            <>
              <Link to="/cart">장바구니</Link>
              <Link to="/login">로그인</Link>
              <Link to="/signup" className="btn btn--primary btn--sm">
                회원가입
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
